import * as z from "zod"

export const equipmentOptions = [
  { value: "tv/projector", label: "TV/Projector" },
  { value: "sound-system", label: "Sound System" },
  { value: "microphone", label: "Microphone" },
  { value: "wifi", label: "Wifi" },
  { value: "onsite-it-support", label: "Onsite IT support" },
  { value: "gender-neutral-bathrooms", label: "Gender neutral bathrooms" },
  { value: "inclusive-access-room", label: "Inclusive access room" },
]

export const facilitiesSchema = z.object({
  available_facilities: z.array(z.string()).optional(),
  possible_disturbances: z.string().optional(),
  on_the_day_contact: z.coerce
    .string<string>()
    .nonempty("Please choose someone we can find on the day"),
})
